import { render, staticRenderFns } from "./GoogleReviews.vue?vue&type=template&id=789a8075&scoped=true"
import script from "./GoogleReviews.vue?vue&type=script&lang=js"
export * from "./GoogleReviews.vue?vue&type=script&lang=js"
import style0 from "./GoogleReviews.vue?vue&type=style&index=0&id=789a8075&prod&scoped=true&lang=scss"
import style1 from "./GoogleReviews.vue?vue&type=style&index=1&id=789a8075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a8075",
  null
  
)

export default component.exports